const useSession = ({
  addLessonSession,
  module,
  isDraft,
  updateLessonSessionData,
  updateLesson,
  isPrivate,
  privateUsers,
  setPrivateUsers,
}) => {
  const onCreateSession = async (formData, type) => {
    const sessionData = { ...formData };

    if (sessionData.time === '') {
      delete sessionData.time;
    }

    const lessonObject = {};
    lessonObject.moduleId = module.id;
    lessonObject.name = sessionData.lessonName;
    lessonObject.isDraft = isDraft;
    lessonObject.description = sessionData.description;
    lessonObject.lessonType = type;
    lessonObject.date = sessionData.date;
    lessonObject.time = sessionData.time || null;
    lessonObject.address = sessionData.street
      ? `${sessionData.street}-${sessionData.streetTwo}-${sessionData.city}-${sessionData.state}-${sessionData.zipCode}`
      : null;
    lessonObject.meetUrl = sessionData.meetUrl || null;
    lessonObject.privateUsers = privateUsers.map(user => user.id);

    const { newLesson, updatedModules } = await addLessonSession(lessonObject);
    const { id } = newLesson;
    setPrivateUsers([]);

    await updateLesson({ id }, updatedModules);
  };

  const onUpdateSession = async formData => {
    const sessionData = { ...formData };

    if (sessionData.time === '') {
      delete sessionData.time;
    }

    const lessonObject = {};
    lessonObject.address = sessionData.street
      ? `${sessionData.street}-${sessionData.streetTwo}-${sessionData.city}-${sessionData.state}-${sessionData.zipCode}`
      : null;
    lessonObject.id = sessionData.id;
    lessonObject.name = sessionData.lessonName;
    lessonObject.isDraft = isDraft;
    lessonObject.description = sessionData.description;
    lessonObject.date = sessionData.date;
    lessonObject.time = sessionData.time || null;
    lessonObject.order = sessionData.order;
    lessonObject.meetUrl = sessionData.meetUrl || null;
    lessonObject.isPrivate = isPrivate;
    lessonObject.privateUsers = privateUsers.map(user => user.id);

    await updateLessonSessionData(lessonObject);
  };

  return {
    onCreateSession,
    onUpdateSession,
  };
};

export default useSession;
